import React, { useState } from "react";

function Prices() {
  const [womenPricesOpen, setWomenPricesOpen] = useState(false);
  const [menPricesOpen, setMenPricesOpen] = useState(false);

  const toggleWomenPrices = () => setWomenPricesOpen(prev => !prev);
  const toggleMenPrices = () => setMenPricesOpen(prev => !prev);

  return (
    <div className="prices">
      <h2>Price List</h2>

      <div className="price-section">
        <button className="price-toggle" onClick={toggleWomenPrices}>
          Price List for Women
        </button>
        {womenPricesOpen && (
          <table className="price-table">
            <thead>
              <tr>
                <th>Service</th>
                <th>1 Session</th>
                <th>3 Sessions</th>
                <th>6 Sessions</th>
                <th>8 Sessions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Upper lip</td>
                <td>£25</td>
                <td>£75</td>
                <td>£135</td>
                <td>£175</td>
              </tr>
              <tr>
                <td>Chin</td>
                <td>£25</td>
                <td>£75</td>
                <td>£135</td>
                <td>£175</td>
              </tr>
              <tr>
                <td>Neck</td>
                <td>£25</td>
                <td>£75</td>
                <td>£135</td>
                <td>£175</td>
              </tr>
              <tr>
                <td>Full Face</td>
                <td>£60</td>
                <td>£180</td>
                <td>£324</td>
                <td>£420</td>
              </tr>
              <tr>
                <td>Half Legs</td>
                <td>£70</td>
                <td>£210</td>
                <td>£378</td>
                <td>£490</td>
              </tr>
              <tr>
                <td>Full Legs</td>
                <td>£110</td>
                <td>£330</td>
                <td>£594</td>
                <td>£770</td>
              </tr>
              <tr>
                <td>Underarms</td>
                <td>£30</td>
                <td>£90</td>
                <td>£162</td>
                <td>£210</td>
              </tr>
              <tr>
                <td>Half Arms</td>
                <td>£50</td>
                <td>£150</td>
                <td>£270</td>
                <td>£350</td>
              </tr>
              <tr>
                <td>Full Arms</td>
                <td>£70</td>
                <td>£210</td>
                <td>£378</td>
                <td>£490</td>
              </tr>
              <tr>
                <td>Tummy Line</td>
                <td>£36</td>
                <td>£108</td>
                <td>£195</td>
                <td>£250</td>
              </tr>
              <tr>
                <td>Brazilian</td>
                <td>£55</td>
                <td>£165</td>
                <td>£297</td>
                <td>£385</td>
              </tr>
              <tr>
                <td>Hollywood</td>
                <td>£75</td>
                <td>£225</td>
                <td>£405</td>
                <td>£525</td>
              </tr>
              <tr>
                <td>Full Front</td>
                <td>£50</td>
                <td>£150</td>
                <td>£270</td>
                <td>£350</td>
              </tr>
              <tr>
                <td>Full Back</td>
                <td>£50</td>
                <td>£150</td>
                <td>£270</td>
                <td>£350</td>
              </tr>
              <tr>
                <td>Platinum Package (Full Body)</td>
                <td>£445</td>
                <td>£1335</td>
                <td>£2040</td>
                <td>£2480</td>
              </tr>
              <tr>
                <td>Gold Package (Full Arms, Full Legs, Underarms, Hollywood)</td>
                <td>£345</td>
                <td>£1035</td>
                <td>£1552.50</td>
                <td>£1932</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      <div className="price-section">
        <button className="price-toggle" onClick={toggleMenPrices}>
          Price List for Men
        </button>
        {menPricesOpen && (
          <table className="price-table">
            <thead>
              <tr>
                <th>Service</th>
                <th>1 Session</th>
                <th>3 Sessions</th>
                <th>6 Sessions</th>
                <th>8 Sessions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chin</td>
                <td>£30</td>
                <td>£72</td>
                <td>£126</td>
                <td>£168</td>
              </tr>
              <tr>
                <td>Ears</td>
                <td>£30</td>
                <td>£72</td>
                <td>£126</td>
                <td>£168</td>
              </tr>
              <tr>
                <td>Eyebrows</td>
                <td>£10</td>
                <td>£24</td>
                <td>£42</td>
                <td>£56</td>
              </tr>
              <tr>
                <td>Nose</td>
                <td>£30</td>
                <td>£72</td>
                <td>£126</td>
                <td>£168</td>
              </tr>
              <tr>
                <td>Sideburns</td>
                <td>£40</td>
                <td>£96</td>
                <td>£168</td>
                <td>£280</td>
              </tr>
              <tr>
                <td>Full Face</td>
                <td>£65</td>
                <td>£156</td>
                <td>£273</td>
                <td>£364</td>
              </tr>
              <tr>
                <td>Neck (Front and Back)</td>
                <td>£50</td>
                <td>£120</td>
                <td>£210</td>
                <td>£280</td>
              </tr>
              <tr>
                <td>Beard Sculpting</td>
                <td>£80</td>
                <td>£192</td>
                <td>£336</td>
                <td>£448</td>
              </tr>
              <tr>
                <td>Face & Neck</td>
                <td>£90</td>
                <td>£216</td>
                <td>£378</td>
                <td>£504</td>
              </tr>
              <tr>
                <td>Half Legs</td>
                <td>£99</td>
                <td>£237</td>
                <td>£415</td>
                <td>£554</td>
              </tr>
              <tr>
                <td>Full Legs</td>
                <td>£150</td>
                <td>£360</td>
                <td>£630</td>
                <td>£840</td>
              </tr>
              <tr>
                <td>Buttocks</td>
                <td>£60</td>
                <td>£144</td>
                <td>£252</td>
                <td>£336</td>
              </tr>
              <tr>
                <td>Male Brazilian</td>
                <td>£55</td>
                <td>£165</td>
                <td>£297</td>
                <td>£385</td>
              </tr>
              <tr>
                <td>Feet and Toes</td>
                <td>£50</td>
                <td>£120</td>
                <td>£210</td>
                <td>£280</td>
              </tr>
              <tr>
                <td>Underarms</td>
                <td>£30</td>
                <td>£90</td>
                <td>£162</td>
                <td>£210</td>
              </tr>
              <tr>
                <td>Half Arms</td>
                <td>£65</td>
                <td>£156</td>
                <td>£273</td>
                <td>£364</td>
              </tr>
              <tr>
                <td>Full Arms</td>
                <td>£99</td>
                <td>£237</td>
                <td>£415</td>
                <td>£554</td>
              </tr>
              <tr>
                <td>Shoulders</td>
                <td>£30</td>
                <td>£90</td>
                <td>£162</td>
                <td>£210</td>
              </tr>
              <tr>
                <td>Stomach</td>
                <td>£55</td>
                <td>£132</td>
                <td>£231</td>
                <td>£308</td>
              </tr>
              <tr>
                <td>Chest</td>
                <td>£90</td>
                <td>£216</td>
                <td>£378</td>
                <td>£504</td>
              </tr>
              <tr>
                <td>½ Back</td>
                <td>£99</td>
                <td>£237</td>
                <td>£415</td>
                <td>£554</td>
              </tr>
              <tr>
                <td>Full Back</td>
                <td>£145</td>
                <td>£348</td>
                <td>£609</td>
                <td>£812</td>
              </tr>
              <tr>
                <td>Chest & Stomach</td>
                <td>£130</td>
                <td>£312</td>
                <td>£546</td>
                <td>£728</td>
              </tr>
              <tr>
                <td>Back & Shoulders</td>
                <td>£165</td>
                <td>£396</td>
                <td>£693</td>
                <td>£924</td>
              </tr>
              <tr>
                <td>Male Full Body</td>
                <td>£445</td>
                <td>£1335</td>
                <td>£2040</td>
                <td>£2480</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Prices;
